import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './css/overridesquill.css'
import ImageResize from 'quill-image-resize';
import ImageCompress from 'quill-image-compress';
import { Toolbar, container, formats } from './config.js';
import registerBlots from './BlotsRegistration.js';
import EmbedPromptDialog from './EmbedPromptDialog.js';
//ql-twitter

//USED ON ARCTICLE POST INSERT ON LIVE PAGE
const QuillEditor = ({content, onChange, readOnly = false, style}) => {

  const quillRef = useRef();
  const [embedType, setEmbedType] = useState(null);

  // Enregistre les blots une seule fois
  useEffect(() => {
    registerBlots();


  }, []);


let Clipboard = Quill.import('modules/clipboard');
let Delta = Quill.import('delta');

class CustomClipboard extends Clipboard {
  constructor(quill, options) {
    super(quill, options);

   this.addMatcher('IMG', (node, delta) => {

      let newDelta = new Delta();
     
      //TODO autoriser class
      const attributes =  
        {
          width: 1000,
        };

      return newDelta.insert({ image: node.src }, attributes);

      })
    }
}
  
  Quill.register('modules/clipboard', CustomClipboard, true);
  Quill.register('modules/imageResize', ImageResize, true);
  Quill.register('modules/imageCompress', ImageCompress, true);

    const font = Quill.import('attributors/style/font');
    font.whitelist = ['Poppins', 'Source Sans Pro', 'Roboto'];
    Quill.register(font, true);



    useEffect(() => {
      setTimeout(() => {
        if (quillRef.current && quillRef.current.container) {
          const toolbar = quillRef.current.container.previousSibling; // Récupère la toolbar liée à CE QuillEditor
          const imageButton = toolbar?.querySelector(".ql-image"); // Sélectionne le bouton image de CET éditeur
          
          if (imageButton) {
            imageButton.click(); // Simulation du clic
          }
        }
      }, 500);
    }, [quillRef.current]);


     useEffect(() => {
    if (readOnly) return;
    const quill = quillRef?.current?.getEditor();
    if (!quill) return;

  // 🔧 S'assure que le wrapper a bien la hitbox + hint
  const ensureIframeChrome = (wrapper) => {
    if (!wrapper || !wrapper.classList?.contains('ql-iframe-wrapper')) return;

    let hit = wrapper.querySelector('.ql-iframe-embed-hit');
    if (!hit) {
      hit = document.createElement('div');
      hit.className = 'ql-iframe-embed-hit';
      hit.setAttribute('title', 'Options');
      wrapper.appendChild(hit);
    }

    let hint = wrapper.querySelector('.ql-iframe-embed-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'ql-iframe-embed-hint';
      hint.textContent = 'Options d’affichage';
      wrapper.appendChild(hint);
    }
  };

   quill.root
    .querySelectorAll('.ql-iframe-wrapper')
    .forEach((wrapper) => ensureIframeChrome(wrapper));

const setupFreeResize = (wrapper) => {
     if (
    !wrapper ||
    !(
      wrapper.classList?.contains('ql-iframe-wrapper') ||
      wrapper.classList?.contains('ql-facebook-embed-wrapper')
    )
  ) {
    return;
  }

    const handle = wrapper.querySelector('.ql-iframe-resizer');
    if (!handle || handle._freeResizeInit) return;

    handle._freeResizeInit = true;

    handle.addEventListener('mousedown', (evt) => {
      if (wrapper.dataset.ratioMode !== 'free') return; // seulement en mode libre

      evt.preventDefault();
      evt.stopPropagation();

      const rect = wrapper.getBoundingClientRect();
      const startX = evt.clientX;
      const startY = evt.clientY;
      const startWidth  = rect.width;
      const startHeight = rect.height;

      const parentRect = wrapper.parentElement?.getBoundingClientRect();
      const maxWidth = parentRect ? parentRect.width : startWidth;

      const minWidth  = 200;
      const minHeight = 120;

      const onMove = (moveEvt) => {
        const dx = moveEvt.clientX - startX;
        const dy = moveEvt.clientY - startY;

        let newWidth  = startWidth  + dx;
        let newHeight = startHeight + dy;

        newWidth  = Math.max(minWidth,  Math.min(maxWidth, newWidth));
        newHeight = Math.max(minHeight, newHeight);

        // mode "SOS" : on sort de aspect-ratio pur, on fige largeur + hauteur
        wrapper.style.aspectRatio = 'auto';
        wrapper.style.width  = `${newWidth}px`;
        wrapper.style.height = `${newHeight}px`;

        // On continue à stocker un "ratio" maison dans les dataset
        const wInt = Math.round(newWidth);
        const hInt = Math.round(newHeight);

        wrapper.dataset.aspectW = String(wInt);
        wrapper.dataset.aspectH = String(hInt);
        wrapper.style.setProperty('--fb-aspect-w', wInt);
        wrapper.style.setProperty('--fb-aspect-h', hInt);
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);

        // serialize vers le blot (aspectW / aspectH mis à jour)
        syncEmbed(wrapper);
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  };

 const ensureControls = (wrapper) => {
  const isFacebook = wrapper.classList?.contains('ql-facebook-embed-wrapper');
  const isIframe = wrapper.classList?.contains('ql-iframe-wrapper');

  if (!isFacebook && !isIframe) return null;

  const host = wrapper; // le wrapper sert toujours de conteneur overlay

  let panel = isFacebook
    ? host.querySelector('.ql-facebook-embed-controls')
    : host.querySelector('.ql-iframe-controls');

  if (panel) return panel;

  panel = document.createElement('div');
  panel.className = isFacebook
    ? 'ql-facebook-embed-controls'
    : 'ql-iframe-controls';

  // Select du ratio
  const selectRatio = document.createElement('select');

  const ratioOptions = [
    ['16:9', '16:9'],
    ['4:5',  '4:5'],
    ['4:3',  '4:3'],
    ['1:1',  '1:1'],
    ['9:16', '9:16'],
    ['custom', 'Libre'],
  ];
  ratioOptions.forEach(([v, label]) => {
    const opt = document.createElement('option');
    opt.value = v;
    opt.textContent = label;
    selectRatio.appendChild(opt);
  });

  const ratioToAspect = {
    '16:9': { w: 16, h: 9 },
    '4:5':  { w: 4,  h: 5 },
    '4:3':  { w: 4,  h: 3 },
    '1:1':  { w: 1,  h: 1 },
    '9:16': { w: 9,  h: 16 },
  };

  const getRatioKeyFromAspect = (aw, ah) => {
    const r = aw / ah;
    const targets = {
      '16:9': 16 / 9,
      '4:5':  4 / 5,
      '4:3':  4 / 3,
      '1:1':  1,
      '9:16': 9 / 16,
    };
    let bestKey = '16:9';
    let bestDiff = Infinity;
    Object.entries(targets).forEach(([key, target]) => {
      const diff = Math.abs(r - target);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestKey = key;
      }
    });

     // si on s'éloigne trop des ratios standard → "Libre"
    if (bestDiff > 0.05) {
      return 'custom';
    }

    return bestKey;
  };

  const aw = Number(wrapper.dataset.aspectW || 1);
  const ah = Number(wrapper.dataset.aspectH || 1);
   const keyAtInit = getRatioKeyFromAspect(aw, ah);

  selectRatio.value = keyAtInit;
  wrapper.dataset.ratioMode = keyAtInit === 'custom' ? 'free' : 'fixed';

  selectRatio.addEventListener('change', () => {
    const key = selectRatio.value;
    if (key === 'custom') {
      // Mode libre : on ne change pas le ratio existant, on laisse l'utilisateur tirer
      wrapper.dataset.ratioMode = 'free';
      setupFreeResize(wrapper);
      return;
    }

    wrapper.dataset.ratioMode = 'fixed';

    // On remet un ratio classique et on enlève les width/height forcés
    wrapper.style.width = '';
    wrapper.style.height = '';
    wrapper.style.aspectRatio =
      'var(--fb-aspect-w, 16) / var(--fb-aspect-h, 9)';

    const { w, h } = ratioToAspect[key] || ratioToAspect['16:9'];

    wrapper.dataset.aspectW = String(w);
    wrapper.dataset.aspectH = String(h);
    wrapper.style.setProperty('--fb-aspect-w', w);
    wrapper.style.setProperty('--fb-aspect-h', h);

    syncEmbed(wrapper);
  });


 panel.appendChild(selectRatio);
  host.appendChild(panel);

   if (wrapper.dataset.ratioMode === 'free') {
    setupFreeResize(wrapper);
  }

  return panel;
};

  // const syncFacebookEmbed = (wrapper) => {
  //   const blot = Quill.find(wrapper);
 const syncEmbed = (wrapper) => {
    const blot = Quill.find(
      wrapper.classList?.contains('ql-facebook-embed-wrapper')
        ? wrapper
        : wrapper // iframe
    );
    if (!blot) return;
    const index = quill.getIndex(blot);

    // const mode = wrapper.dataset.mode || 'contain';
    // const containWidthPct = Number(wrapper.dataset.containWidthPct || 100); // encore sérialisé mais plus utilisé visuellement
    // const aspectW = Number(wrapper.dataset.aspectW || 16);
    // const aspectH = Number(wrapper.dataset.aspectH || 9);

    // const iframe = wrapper.querySelector('iframe');
    // const src = iframe?.getAttribute('src') || '';
    // const m = src.match(/href=([^&]+)/);
    // const url = m ? decodeURIComponent(m[1]) : '';

    // const Delta = Quill.import('delta');
    // const ops = new Delta()
    //   .retain(index)
    //   .delete(1)
    //   .insert({ facebook: { url, mode, containWidthPct, heightMode:'ratio', aspectW, aspectH } });

    // quill.updateContents(ops, 'user');
    // quill.setSelection(index + 1, 0, 'silent');
     const aspectW = Number(wrapper.dataset.aspectW || 16);
    const aspectH = Number(wrapper.dataset.aspectH || 9);

    const Delta = Quill.import('delta');

    let insertOp = null;

    // Cas 1 : Facebook
    const fbRoot = wrapper.closest?.('.ql-facebook-embed');
    if (fbRoot) {
      const mode = wrapper.dataset.mode || 'contain';
      const containWidthPct = Number(wrapper.dataset.containWidthPct || 100);
      const iframe = wrapper.querySelector('iframe');
      const src = iframe?.getAttribute('src') || '';
      const m = src.match(/href=([^&]+)/);
      const url = m ? decodeURIComponent(m[1]) : '';

      insertOp = { facebook: { url, mode, containWidthPct, heightMode: 'ratio', aspectW, aspectH } };
     } else {
    // Cas 2 : iframe générique (wrapper .ql-iframe-wrapper)
    const iframe = wrapper.querySelector('iframe');
    const src = iframe?.getAttribute('src') || '';

    wrapper.dataset.aspectW = String(aspectW);
    wrapper.dataset.aspectH = String(aspectH);
    wrapper.style.setProperty('--fb-aspect-w', aspectW);
    wrapper.style.setProperty('--fb-aspect-h', aspectH);

    insertOp = { iframe: { iframe: src, aspectW, aspectH } };
  }

  if (!insertOp) return;

  const ops = new Delta()
    .retain(index)
    .delete(1)
    .insert(insertOp);

  quill.updateContents(ops, 'user');
  quill.setSelection(index + 1, 0, 'silent');
};

const onClick = (e) => {
  // 1) Facebook : clic sur “Format”
  const fbTrigger = e.target.closest('.ql-facebook-embed-hit, .ql-facebook-embed-hint');
  if (fbTrigger) {
    const fbWrapper = fbTrigger.closest('.ql-facebook-embed-wrapper');
    if (fbWrapper) ensureControls(fbWrapper);
    return;
  }

  // 2) Clic dans le wrapper Facebook
  const fbWrapper = e.target.closest('.ql-facebook-embed-wrapper');
  if (fbWrapper) {
    ensureControls(fbWrapper);
    return;
  }

   // 3) Iframe classique : clic sur “Format”
  const iframeTrigger = e.target.closest('.ql-iframe-embed-hit, .ql-iframe-embed-hint');
  if (iframeTrigger) {
    const ifWrapper = iframeTrigger.closest('.ql-iframe-wrapper');
    if (ifWrapper) {
      ensureIframeChrome(ifWrapper);  // 🔧 au cas où
      ensureControls(ifWrapper);
    }
    return;
  }

  // 4) Clic dans le wrapper iframe
  const iframeWrapper = e.target.closest('.ql-iframe-wrapper');
  if (iframeWrapper) {
    ensureIframeChrome(iframeWrapper); // 🔧 au cas où
    ensureControls(iframeWrapper);
    return;
  }
};

  const root = quill.root;
  root.addEventListener('click', onClick, { capture:true });
  return () => root.removeEventListener('click', onClick, { capture:true });
}, [readOnly]);


// Normalise ce que l'utilisateur colle pour Facebook (URL ou code <iframe>)
const normalizeFacebookInput = (raw) => {
  if (!raw) return '';
  let v = raw.trim();

  const m1 = v.match(/src="([^"]+)"/i) || v.match(/href="([^"]+)"/i);
  if (m1) {
    let u = m1[1];
    try {
      u = decodeURIComponent(u);
    } catch {}
    const inner = u.match(/[?&]href=([^&]+)/);
    if (inner) {
      try {
        return decodeURIComponent(inner[1]);
      } catch {
        return inner[1];
      }
    }
    return u;
  }
  return v;
};

const handleInsertEmbed = (type, data) => {
  const quill = quillRef?.current?.getEditor();
  if (!quill) return;

  let raw = '';
  let inputMode = 'url'; // 'url' | 'embed'

  if (typeof data === 'string') {
    raw = data;
  } else if (data && typeof data.value === 'string') {
    raw = data.value;
    if (data.mode) inputMode = data.mode;
  }

  raw = raw.trim();
  if (!raw) return;

  let payload;

  if (type === 'iframe') {
    // IFRAME GENERIQUE : URL ou code <iframe>
    let finalUrl = raw;
    let aspectW = 16;
    let aspectH = 9;

    // Si l'utilisateur a collé un <iframe> complet, on essaie d'extraire src + width/height
    if (/<iframe[\s\S]*?>/i.test(raw)) {
      const srcMatch = raw.match(/src="([^"]+)"/i);
      if (srcMatch) {
        finalUrl = srcMatch[1];
      }

      let w = NaN;
      let h = NaN;

      const wAttr = raw.match(/width="(\d+)"/i);
      const hAttr = raw.match(/height="(\d+)"/i);
      if (wAttr) w = parseInt(wAttr[1], 10);
      if (hAttr) h = parseInt(hAttr[1], 10);

      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        const wParam = raw.match(/[?&]width=(\d+)/i);
        const hParam = raw.match(/[?&]height=(\d+)/i);
        if (wParam) w = parseInt(wParam[1], 10);
        if (hParam) h = parseInt(hParam[1], 10);
      }

      if (w > 0 && h > 0) {
        aspectW = w;
        aspectH = h;
      }
    }

    // Si ce n'est pas un iframe, on garde juste l'URL et le ratio par défaut 16:9
    payload = { iframe: finalUrl, aspectW, aspectH };

  } else if (type === 'facebook') {
    // FACEBOOK : URL ou code <iframe>
    const rawFb = raw;

    // Par défaut : carré (1:1)
    let aspectW = 1;
    let aspectH = 1;

    if (/<iframe[\s\S]*?>/i.test(rawFb)) {
      let w = NaN;
      let h = NaN;

      const wAttr = rawFb.match(/width="(\d+)"/i);
      const hAttr = rawFb.match(/height="(\d+)"/i);
      if (wAttr) w = parseInt(wAttr[1], 10);
      if (hAttr) h = parseInt(hAttr[1], 10);

      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        const wParam = rawFb.match(/[?&]width=(\d+)/i);
        const hParam = rawFb.match(/[?&]height=(\d+)/i);
        if (wParam) w = parseInt(wParam[1], 10);
        if (hParam) h = parseInt(hParam[1], 10);
      }

      if (w > 0 && h > 0) {
        aspectW = w;
        aspectH = h;
      }
    }

    const cleanUrl = normalizeFacebookInput(rawFb);

    payload = {
      url: cleanUrl,
      mode: 'contain',
      heightMode: 'ratio',
      aspectW,
      aspectH,
      containWidthPct: 100,
    };

  } else {
    // twitter / instagram → URL simple
    payload = { url: raw };
  }

  const index = quill.getSelection()?.index || quill.getLength();
  quill.insertText(index, '\n', 'user');
  quill.insertEmbed(index, type, payload);
};

const handlers = {
  iframe: () => setEmbedType('iframe'),
  twitter: () => setEmbedType('twitter'),
  instagram: () => setEmbedType('instagram'),
  facebook: () => setEmbedType('facebook'),
};

    const modules = useMemo(() => {
      if(readOnly)
        return {
          toolbar : null
        }

      return {
        toolbar : {
          container : "#toolbar-container",
          handlers : handlers,
        },
        clipboard: true, // CustomClipboard

        imageResize: {
          modules: [ 'Resize', 'DisplaySize' ]
        },
        imageCompress: {
          quality: 0.7, // default
          maxWidth: 1000, // default
          maxHeight: 1000, // default
          imageType: 'image/jpeg', // default
          debug: true, // default
        } 
    }
 
    }, [readOnly])

    const handleImageClick = useCallback((e) => {
      const quill = quillRef?.current?.getEditor();
      const image = e.target;
  
      if (quill && image.tagName === 'IMG') {
        // Désélectionne toutes les autres images
        quill.root.querySelectorAll('img').forEach((img) => {
          if (img !== image) {
            img.classList.remove('selected-image');
          }
        });
  
        // Sélectionne ou désélectionne l'image cliquée
        image.classList.toggle('selected-image');

        // Fonction pour trouver l'index de l'image dans le contenu Quill
        function findImageIndexInQuill(quillInstance, targetImage) {
          const delta = quillInstance.getContents();
          let currentIndex = 0;

          for (const op of delta.ops) {
            if (op.insert && typeof op.insert === 'string') {
              currentIndex += op.insert.length;
            } else if (op.insert && typeof op.insert === 'object' && op.insert.image) {
              currentIndex += 1;
        
              if (op.insert.image === targetImage.src) {
                return currentIndex;
              }
            }
          }
        
          return currentIndex;
        }


        // Obtient l'index de l'image dans le contenu Quill
        const index = findImageIndexInQuill(quill, image);

        // Déplace le curseur juste avant l'image
        quill.setSelection(index);
      }
    }, [content]);

    useEffect(() => {
      const quill = quillRef?.current?.getEditor();
  
      if (quill) {
        quill.root.addEventListener('click', handleImageClick);
  
        // Nettoyer l'écouteur d'événements lorsque le composant est démonté
        return () => {
          quill.root.removeEventListener('click', handleImageClick);
        };
      }
    }, [quillRef]);

    return (
        <>
          <Toolbar readOnly={readOnly}/>
          <ReactQuill ref={quillRef} theme="snow"
          value={content}
          
          modules={modules}
          formats={formats}

          onChange={onChange}

          placeholder="Saisissez votre texte ici..."
          style={style}
          readOnly={readOnly}
          />

          <EmbedPromptDialog
            open={Boolean(embedType)}
            embedType={embedType}
            onClose={() => setEmbedType(null)}
            onConfirm={(payload) => {
              handleInsertEmbed(embedType, payload);
              setEmbedType(null);
            }}
          />
        </>
        
    )

}

export default QuillEditor